import React from "react";
import { Toast } from "primereact/toast";

const BaseToast = React.forwardRef((props,ref) => {
  return (
    <Toast {...props} ref={ref} className={`${props.custom ? props.custom : ""} ${props.extra ? props.extra : ""}`}/>
  );
})

export default BaseToast;